import React from "react";

export default function Loader() {
  return (
    <div className="flex justify-center items-center h-full z-10 pt-[20rem]">
      <div className="loader">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>
    </div>
  );
}
